import { render, staticRenderFns } from "./alarms-expand-panel-tab-item-wrapper.vue?vue&type=template&id=4785e470&scoped=true&"
import script from "./alarms-expand-panel-tab-item-wrapper.vue?vue&type=script&lang=js&"
export * from "./alarms-expand-panel-tab-item-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./alarms-expand-panel-tab-item-wrapper.vue?vue&type=style&index=0&id=4785e470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4785e470",
  null
  
)

export default component.exports